// extracted by mini-css-extract-plugin
export default {"Container":"Referral_Container__P14R3","info":"Referral_info__8abzm"};